export default "__VITE_ASSET__CkXil60r__"